import React, { useEffect, useState } from 'react'
import AxiosInstance from 'utils/AxiosInstance'
import './style.css'

import {
  Card,
  CardBody,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Progress,
  Row,
  Spinner,
} from 'reactstrap'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { fetchCoursesOverview } from 'store/Dashboard/actions'
import { useCoursesOverviews } from '../Admin/useCoursesOverviews'
import Loader from 'views/pages/Loader'
function getColor(percentage) {
  if (percentage <= 25) {
    return 'red'
  } else if (percentage <= 50) {
    return 'orange'
  } else if (percentage <= 75) {
    return 'blue'
  } else {
    return 'green'
  }
}

function CourseOverview() {
  useCoursesOverviews()
  const {
    coursesOverviewsData: { coursesOverview, loadingCoursesOverview },
  } = useSelector((state) => state.dashboard)

  return (
    <Card className='h-100'>
      <CardHeader>
        <h5 className='h3 mb-0'>Latest Results</h5>
      </CardHeader>

      <CardBody className={`scrollbar overflow-auto `}>
        {loadingCoursesOverview ? (
          <Loader />
        ) : (
          <ListGroup className='list' flush>
            {coursesOverview &&
              coursesOverview.length &&
              coursesOverview.map((course) => {
                const validContents = course.finishedContents.filter(
                  (content) => course.contents.includes(+content)
                )

                const percentage = Math.floor(
                  (validContents.length / course.contents.length) * 100
                )
                return (
                  <ListGroupItem key={course.name} className='px-0'>
                    <Row className='align-items-center'>
                      {/*<div className="col-sm-10 col-md-11">*/}
                      <div className='col'>
                        <h5>{course.name}</h5>
                        <Progress
                          className='progress-xs mb-0'
                          color={getColor(percentage)}
                          max='100'
                          value={percentage}
                        />
                      </div>
                      <div
                        className={`px-0 text-center text-${getColor(
                          percentage
                        )}`}
                        style={{ width: '50px' }}
                        // className={` text-center text-${getColor(percentage)}`}
                      >
                        {percentage <= 100 ? percentage : 100}%
                      </div>
                    </Row>
                  </ListGroupItem>
                )
              })}
          </ListGroup>
        )}
      </CardBody>
    </Card>
  )
}

export default CourseOverview
